// extracted by mini-css-extract-plugin
export default {"timelineWrapper":"styles_timelineWrapper__mxn-K","timelineMainContainer":"styles_timelineMainContainer__n3aTN"};